module.exports = __webpack_public_path__ + "media/images/icons/outlined/security-scan-01dda888a78d52f200dfd3a337ad01e1.svg";